import { httpService } from "utils";

export const getRecaptcha = () => {
  return httpService().get<string>(`/contexts/recaptcha`);
};

export const getRecaptchaKey = () => "recaptacha";
